
export const strongTranslationsRU = {
  "G11": {
    m: "Авраам",
    d: "Патриарх Авраам, отец верующих.",
    u: "Используется 73 раза в НЗ. Образец веры.",
    e: "От еврейского אַבְרָהָם (Аврахам) = отец множества"
  },
  "G25": {
    m: "любить божественной и безусловной любовью",
    d: "Любить бескорыстной, жертвенной и божественной любовью. Это любовь Бога к человечеству и любовь, которую мы должны иметь друг к другу.",
    u: "Используется 143 раза в НЗ. Описывает божественную, совершенную и безусловную любовь.",
    e: "От ἄγω (аго) = вести, направлять к добру"
  },
  "G26": {
    m: "божественная любовь, милосердие",
    d: "Совершенная любовь Бога; братская любовь, привязанность, благоволение, милосердие. Любовь, которая соединяет Бога и человека, и человека с ближним.",
    u: "Используется 116 раз в НЗ. Центральное слово христианства для описания божественной любви.",
    e: "Происходит от ἀγαπάω (агапао)"
  },
  "G27": {
    m: "возлюбленный, дорогой",
    d: "Любимый, дорогой; возлюбленный Богом или людьми.",
    u: "Используется 61 раз в НЗ. Возлюбленный Сын Божий.",
    e: "От ἀγαπάω (агапао) = любить"
  },
  "G32": {
    m: "ангел, вестник",
    d: "Вестник; небесный ангел на служении Богу.",
    u: "Используется 175 раз в НЗ. Ангелы Божии.",
    e: "От ἀγγέλλω (ангелло) = возвещать"
  },
  "G36": {
    m: "незнатного рода, презренный",
    d: "Без знатности, низкого происхождения; презираемый.",
    u: "Используется 1 раз в НЗ (1 Кор 1:28).",
    e: "От ἀ- (отрицание) + γένος (генос) = рождение"
  },
  "G93": {
    m: "неправда, беззаконие",
    d: "Нарушение права, несправедливость; нечестие, моральное беззаконие.",
    u: "Используется 25 раз в НЗ. Противоположность δικαιοσύνη (правда).",
    e: "От ἀ- (отрицание) + δίκη (дике) = право"
  },
  "G154": {
    m: "просить, умолять, молить",
    d: "Просить, умолять о чём-то, молить, ходатайствовать. Смиренная и почтительная просьба.",
    u: "Используется 70 раз в НЗ. Просьба, обращённая к Богу или людям.",
    e: "От αἰτέω (айтео) первичный корень; просить"
  },
  "G166": {
    m: "вечный, непрестанный",
    d: "Без начала и конца, всегда существующий; в НЗ часто связано с вечной жизнью в Боге.",
    u: "Используется 71 раз в НЗ. Часто характеризует вечную жизнь и Царство Божие.",
    e: "От αἰών (айон) = век, эпоха, вечность"
  },
  "G225": {
    m: "истина, правда",
    d: "То, что истинно в вещах, касающихся Бога и обязанностей человека; божественная откровенная истина.",
    u: "Используется 109 раз в НЗ. Центральное понятие учения Иисуса.",
    e: "От ἀληθής (алетхес) = истинный, искренний"
  },
  "G281": {
    m: "аминь, истинно",
    d: "Формула утверждения: да будет так, истинно, конечно.",
    u: "Используется 129 раз в НЗ. Иисус говорит 'Истинно, истинно'.",
    e: "От еврейского אָמֵן (амен) = твёрдый, верный"
  },
  "G444": {
    m: "человек, человеческое существо",
    d: "Человеческое существо, мужчина или женщина; человечество в целом.",
    u: "Используется 550 раз в НЗ. Человек, созданный по образу Божию.",
    e: "От ἀνήρ (анер) = муж и ὤψ (опс) = лицо"
  },
  "G622": {
    m: "терять, губить, погибать",
    d: "Разрушать полностью; терять, погибать; быть погублённым.",
    u: "Используется 90 раз в НЗ. Спасать погибшее.",
    e: "От ἀπό (апо) = от + ὄλλυμι (оллуми) = разрушать"
  },
  "G649": {
    m: "посылать, делегировать",
    d: "Посылать с миссией; делегировать как посланника.",
    u: "Используется 132 раза в НЗ. Отец посылает Сына.",
    e: "От ἀπό (апо) = от + στέλλω (стелло) = посылать"
  },
  "G721": {
    m: "агнец",
    d: "Маленький ягнёнок; обозначает Иисуса Христа как Агнца Божия.",
    u: "Используется 30 раз в НЗ, особенно в Откровении.",
    e: "Уменьшительное от ἀρήν (арен) = агнец"
  },
  "G730": {
    m: "мужской, мужчина",
    d: "Мужского пола, мужчина.",
    u: "Используется 9 раз в НЗ. Бог сотворил человека мужчиной и женщиной.",
    e: "Первичный корень"
  },
  "G740": {
    m: "хлеб",
    d: "Хлеб, пища; хлеб жизни = Христос.",
    u: "Используется 97 раз в НЗ. Иисус хлеб жизни.",
    e: "От ἄρω (аро) = поднимать, возносить"
  },
  "G746": {
    m: "начало, источник",
    d: "Начало, происхождение, первый принцип. В Иоанна 1:1-2 обозначает вечное начало, где уже существовало Слово (Логос).",
    u: "Используется 55 раз в НЗ. Ключевое слово Иоанна 1:1 'В начале было Слово'.",
    e: "Первичное слово; начало, первый источник"
  },
  "G772": {
    m: "слабый, больной",
    d: "Без силы, слабый; больной, немощный; духовно слабый.",
    u: "Используется 25 раз в НЗ. Бог избирает немощное мира.",
    e: "От ἀ- (отрицание) + σθένος (стхенос) = сила"
  },
  "G907": {
    m: "крестить, погружать",
    d: "Погружать в воду; крестить для очищения или посвящения.",
    u: "Используется 77 раз в НЗ. Христианское крещение.",
    e: "От βάπτω (бапто) = погружать, окунать"
  },
  "G1080": {
    m: "рождать, производить",
    d: "Рождать, давать рождение; родиться вновь духовно.",
    u: "Используется 97 раз в НЗ. Родиться от Бога, родиться свыше.",
    e: "Первичный корень"
  },
  "G1096": {
    m: "становиться, происходить, случаться",
    d: "Становиться, приходить в существование, происходить, случаться.",
    u: "Используется 678 раз в НЗ. 'Все чрез Него начало быть' (Иоан. 1:3).",
    e: "От γίνομαι (гиномай) = становиться"
  },
  "G1097": {
    m: "знать, ведать, понимать",
    d: "Знать через личный опыт; понимать, воспринимать, сознавать.",
    u: "Используется 222 раза в НЗ. Опытное знание, не только интеллектуальное.",
    e: "Индоевропейский корень *gen- = порождать, знать"
  },
  "G1100": {
    m: "язык, речь",
    d: "Орган речи; язык, диалект; дар языков.",
    u: "Используется 50 раз в НЗ. Дар языков.",
    e: "Первичный корень"
  },
  "G1166": {
    m: "показывать, демонстрировать",
    d: "Выставлять перед глазами, показывать; доказывать, демонстрировать.",
    u: "Используется 33 раза в НЗ. Бог показывает Свою славу.",
    e: "Первичный корень"
  },
  "G1208": {
    m: "второй",
    d: "Второй в ряду или порядке.",
    u: "Используется 44 раза в НЗ. Вторая заповедь.",
    e: "От δύο (дюо) = два"
  },
  "G1271": {
    m: "разум, мысль",
    d: "Способность думать, слышать, понимать; ум, понимание.",
    u: "Используется 12 раз в НЗ. Ум, обновлённый Христом.",
    e: "От διά (диа) = через + νοῦς (ноус) = ум"
  },
  "G1320": {
    m: "учитель, наставник, преподаватель",
    d: "Учитель, наставник; тот, кто учит религиозным истинам.",
    u: "Используется 59 раз в НЗ. 'Равви, мы знаем, что Ты учитель, пришедший от Бога' (Иоан. 3:2).",
    e: "От διδάσκω (дидаско) = учить"
  },
  "G1325": {
    m: "давать, даровать",
    d: "Давать что-то кому-то; даровать, позволять; предавать.",
    u: "Используется 415 раз в НЗ. Бог даёт щедро.",
    e: "Первичный корень"
  },
  "G1372": {
    m: "жаждать, сильно желать",
    d: "Страдать от жажды; сильно желать, стремиться к.",
    u: "Используется 16 раз в НЗ. Духовная жажда Бога.",
    e: "От δίψα (дипса) = жажда"
  },
  "G1401": {
    m: "раб, слуга",
    d: "Раб, слуга; добровольный слуга Божий.",
    u: "Используется 124 раза в НЗ. Слуги Христовы.",
    e: "От δέω (део) = связывать"
  },
  "G1411": {
    m: "сила, мощь, чудо",
    d: "Сила, мощь, способность; акт силы, чудо.",
    u: "Используется 120 раз в НЗ. Сила Божия, Святого Духа.",
    e: "От δύναμαι (динамай) = быть способным"
  },
  "G1417": {
    m: "два",
    d: "Число два; пара.",
    u: "Используется 135 раз в НЗ. Два или три свидетеля.",
    e: "Первичный корень"
  },
  "G1473": {
    m: "я, меня",
    d: "Личное местоимение первого лица единственного числа.",
    u: "Используется 2567 раз в НЗ. Очень частое.",
    e: "Первичное местоимение"
  },
  "G1484": {
    m: "народ, племя, язычники",
    d: "Народ, племя; языческие народы (не-иудеи).",
    u: "Используется 162 раза в НЗ. Евангелие для всех народов.",
    e: "Первичный корень"
  },
  "G1492": {
    m: "знать, видеть, понимать",
    d: "Знать через восприятие, видеть, понимать, осознавать. Знание, полученное через опыт или откровение.",
    u: "Используется 666 раз в НЗ. Основной глагол знания в Евангелии от Иоанна.",
    e: "Совершенная форма εἴδω (эйдо); видеть, знать"
  },
  "G1510": {
    m: "быть, существовать",
    d: "Глагол 'быть' во всех его значениях; существовать, пребывать, происходить.",
    u: "Самый используемый глагол в НЗ (2460+ раз).",
    e: "Первичный корень"
  },
  "G1515": {
    m: "мир",
    d: "Состояние спокойствия; мир с Богом; согласие между людьми.",
    u: "Используется 92 раза в НЗ. Мир Христов.",
    e: "От εἴρω (эйро) = соединять, связывать"
  },
  "G1520": {
    m: "один, единственный",
    d: "Один единственный; единственный, только; некий.",
    u: "Используется 344 раза в НЗ. Единство Бога, единая церковь.",
    e: "Первичный корень"
  },
  "G1586": {
    m: "избирать, выбирать",
    d: "Избирать для себя, выбирать; избирать божественной благодатью.",
    u: "Используется 21 раз в НЗ. Бог избирает Своих детей.",
    e: "От ἐκ (эк) = из + λέγω (лего) = избирать"
  },
  "G1658": {
    m: "свободный, освобождённый",
    d: "Свободный, не раб; освобождённый от рабства греха.",
    u: "Используется 23 раза в НЗ. Освобождённые во Христе.",
    e: "Вероятно от ἔρχομαι (эрхомай) = приходить"
  },
  "G1672": {
    m: "грек, еллин",
    d: "Грек по рождению или языку; не-иудей.",
    u: "Используется 25 раз в НЗ. Нет иудея, ни еллина во Христе.",
    e: "От Ἑλλάς (Эллас) = Греция"
  },
  "G1680": {
    m: "надежда, уверенное ожидание",
    d: "Ожидание благих вещей, надежда, основанная на Боге; уверенность в будущем, основанная на божественных обетованиях.",
    u: "Используется 54 раза в НЗ. Одна из трёх богословских добродетелей вместе с верой и любовью.",
    e: "От ἔλπω (эльпо) = ждать, надеяться"
  },
  "G1743": {
    m: "укреплять, делать сильным",
    d: "Делать сильным, укреплять; давать силу.",
    u: "Используется 8 раз в НЗ. Бог укрепляет верующих.",
    e: "От ἐν (эн) = в + δυναμόω (динамоо) = делать сильным"
  },
  "G1746": {
    m: "облекаться, одеваться",
    d: "Надевать одежду; облекаться качеством или силой.",
    u: "Используется 27 раз в НЗ. Облечься во Христа, облечься в броню Божию.",
    e: "От ἐν (эн) = в + δύω (дюо) = входить, облекаться"
  },
  "G1785": {
    m: "заповедь, повеление",
    d: "Приказ, заповедь, предписание; особенно божественная заповедь.",
    u: "Используется 67 раз в НЗ. Заповеди Бога и Христа.",
    e: "От ἐντέλλομαι (энтелломай) = повелевать"
  },
  "G1848": {
    m: "презирать, относиться с презрением",
    d: "Считать ничем, презирать; относиться с пренебрежением.",
    u: "Используется 11 раз в НЗ. Мир презирает то, что избирает Бог.",
    e: "От ἐξ (экс) = из + οὐθείς (утхейс) = никто"
  },
  "G2041": {
    m: "дело, труд, деяние",
    d: "Работа, труд; действие, поступок; совершённое дело.",
    u: "Используется 169 раз в НЗ. Дела Божии, добрые дела.",
    e: "От ἔργω (эрго) = работать"
  },
  "G2048": {
    m: "пустыня, пустынный",
    d: "Пустынное место, пустыня; пустынный, безлюдный.",
    u: "Используется 48 раз в НЗ. 40 дней Иисуса в пустыне.",
    e: "От ἔρημος (эремос) = заброшенный"
  },
  "G2065": {
    m: "спрашивать, вопрошать, расспрашивать",
    d: "Спрашивать, вопрошать, расспрашивать для получения информации. Исследование или расследование.",
    u: "Используется 63 раза в НЗ. Вопрошание для получения ответов.",
    e: "Неопределённый корень; спрашивать, вопрошать"
  },
  "G2189": {
    m: "вражда, враждебность",
    d: "Ненависть, враждебность, вражда.",
    u: "Используется 6 раз в НЗ. Вражда с Богом упразднена.",
    e: "От ἐχθρός (эхтхрос) = враг"
  },
  "G2205": {
    m: "ревность, зависть",
    d: "Страстное усердие; может быть положительным (ревность о Боге) или отрицательным (зависть).",
    u: "Используется 16 раз в НЗ. Может быть добродетелью или пороком в зависимости от контекста.",
    e: "От ζέω (зео) = кипеть, быть пламенным"
  },
  "G2222": {
    m: "жизнь",
    d: "Физическая или духовная жизнь; вечная жизнь в Боге.",
    u: "Используется 135 раз в НЗ. Иисус есть жизнь.",
    e: "От ζάω (зао) = жить"
  },
  "G2258": {
    m: "был, он был",
    d: "Был, он был, она была. Форма прошедшего времени глагола быть (εἰμί). Выражает состояние или существование в прошлом.",
    u: "Используется 267 раз в НЗ. Ключевое слово в Иоанна 1:1 'В начале было Слово'.",
    e: "Прошедшее время от εἰμί (эйми) = быть; был"
  },
  "G2296": {
    m: "удивляться, изумляться, восхищаться",
    d: "Удивляться, изумляться, поражаться, восхищаться. Реакция удивления на что-то необычайное.",
    u: "Используется 43 раза в НЗ. Частая реакция на чудеса и учения Иисуса.",
    e: "От θαῦμα (тавма) = чудо; удивляться"
  },
  "G2316": {
    m: "Бог, божество",
    d: "Высшее Божество - особенно (с артиклем) единый истинный Бог. В Писании являет единого Бога, который проявляется как Отец, Сын и Святой Дух, без разделения божественной сущности.",
    u: "Используется 1343 раза в НЗ согласно библейским источникам. Центральное слово, обозначающее единого истинного Бога.",
    e: "Неопределенного происхождения согласно Стронгу. Обозначает божество, особенно высшее Божество. Библейское употребление: являет живого Бога, действующего в истории спасения."
  },
  "G2338": {
    m: "женский, женщина",
    d: "Женского пола, женщина.",
    u: "Используется 5 раз в НЗ. Мужчина и женщина равны во Христе.",
    e: "От θηλάζω (тхелазо) = кормить грудью"
  },
  "G2362": {
    m: "престол",
    d: "Царское седалище, престол; царская власть и могущество.",
    u: "Используется 62 раза в НЗ. Престол Бога и Агнца.",
    e: "Первичный корень"
  },
  "G2381": {
    m: "Фома",
    d: "Фома, собственное имя. Один из двенадцати апостолов, также называемый Дидим (близнец). Известен требованием доказательств воскресения.",
    u: "Используется 11 раз в НЗ. Апостол, который сомневался, а затем поверил.",
    e: "От арамейского תְּאוֹמָא (теома) = близнец"
  },
  "G2398": {
    m: "собственный, особенный, личный",
    d: "Собственный, особенный, личный, частный. То, что принадлежит собственно кому-то, отличное от других.",
    u: "Используется 114 раз в НЗ. Понятие личной принадлежности и различия.",
    e: "От неопределенного корня; собственный, особенный"
  },
  "G2424": {
    m: "Иисус",
    d: "Иисус из Назарета, Мессия, Спаситель.",
    u: "Используется 917 раз в НЗ. Имя превыше всякого имени.",
    e: "От еврейского יְהוֹשֻׁעַ (Йегошуа) = Господь спасает"
  },
  "G2453": {
    m: "иудей, иудейский",
    d: "Принадлежащий к иудейской расе; житель Иудеи.",
    u: "Используется 195 раз в НЗ. Иудеи, избранный народ Божий.",
    e: "От Ἰούδας (Иудас) = Иуда"
  },
  "G2491": {
    m: "Иоанн",
    d: "Иоанн, собственное имя. Иоанн Креститель предтеча, Иоанн любимый апостол, автор Евангелия и посланий.",
    u: "Используется 135 раз в НЗ. Имя двух великих фигур НЗ.",
    e: "От еврейского יוֹחָנָן (Йоханан) = YHWH милостив"
  },
  "G2531": {
    m: "как, по мере того как",
    d: "Как, таким же образом; по мере того как, насколько.",
    u: "Используется 182 раза в НЗ. Сравнительный союз.",
    e: "От κατά (ката) = по + ὡς (хос) = как"
  },
  "G2537": {
    m: "новый, свежий",
    d: "Новый по времени или качеству; свежий, недавний, неиспользованный.",
    u: "Используется 42 раза в НЗ. Новое творение, новая заповедь.",
    e: "Корень неясен"
  },
  "G2570": {
    m: "добрый, прекрасный",
    d: "Добрый по природе, прекрасный; почтенный, превосходный, добродетельный.",
    u: "Используется 100 раз в НЗ. Добрый пастырь, добрые дела.",
    e: "Первичный корень"
  },
  "G2588": {
    m: "сердце",
    d: "Физическое сердце; центр внутренней жизни, душа, дух; мысли и чувства.",
    u: "Используется 156 раз в НЗ. Средоточие духовной жизни.",
    e: "Первичный корень"
  },
  "G2596": {
    m: "по, против, через",
    d: "Предлог с несколькими значениями: по, согласно; против; через.",
    u: "Используется более 470 раз в НЗ. Очень частый предлог.",
    e: "Первичный предлог"
  },
  "G2617": {
    m: "посрамлять, бесчестить",
    d: "Посрамлять, бесчестить; смущать, унижать.",
    u: "Используется 13 раз в НЗ. Бог посрамляет мудрых мира.",
    e: "От κατά (ката) = против + αἰσχύνω (айсхюно) = стыдиться"
  },
  "G2744": {
    m: "хвалиться, гордиться",
    d: "Хвалиться, гордиться; находить гордость в чём-то.",
    u: "Используется 37 раз в НЗ. Хвалиться в Господе.",
    e: "От καῦχος (каухос) = хвастовство"
  },
  "G2889": {
    m: "мир, вселенная, человечество",
    d: "Мировой порядок, вселенная; падшее человечество; система, противная Богу.",
    u: "Используется 186 раз в НЗ. Может обозначать творение или греховную систему.",
    e: "От κοσμέω (космео) = украшать, устраивать"
  },
  "G2919": {
    m: "судить, решать",
    d: "Судить, произносить суждение; решать, определять.",
    u: "Используется 114 раз в НЗ. Бог судит мир.",
    e: "Первичный корень"
  },
  "G2920": {
    m: "суд, правосудие, осуждение",
    d: "Суд, правосудие, осуждение, судебное решение. Суд Божий, справедливый и совершенный.",
    u: "Используется 47 раз в НЗ. Центральное понятие божественной справедливости.",
    e: "От κρίνω (крино) = судить, решать"
  },
  "G2962": {
    m: "Господь, Владыка, хозяин",
    d: "Господь, Владыка; титул уважения и божественной власти; Иисус как Господь.",
    u: "Используется 748 раз в НЗ. 'Фома сказал Ему: Господи, не знаем, куда идешь' (Иоан. 14:5).",
    e: "От κύριος (куриос) = иметь власть"
  },
  "G2992": {
    m: "народ",
    d: "Народ, племя; особенно народ Божий (Израиль или Церковь).",
    u: "Используется 142 раза в НЗ. Избранный народ Божий.",
    e: "Первичный корень"
  },
  "G3022": {
    m: "белый, светлый",
    d: "Белый, сияющий; символ чистоты и победы.",
    u: "Используется 25 раз в НЗ. Белые одежды искупленных.",
    e: "От λευκός (леукос) = белый, светлый"
  },
  "G3056": {
    m: "слово, речь, разум",
    d: "Произнесённое слово; разум, мысль; Логос = Христос.",
    u: "Используется 330 раз в НЗ. Воплощённый Логос.",
    e: "От λέγω (лего) = говорить"
  },
  "G3101": {
    m: "ученик, учащийся",
    d: "Учащийся, студент, ученик; последователь Иисуса.",
    u: "Используется 261 раз в НЗ. Обозначает последователей Христа.",
    e: "От μανθάνω (мантхано) = учиться"
  },
  "G3141": {
    m: "свидетельство, засвидетельствование",
    d: "Свидетельство, засвидетельствование, доказательство. Свидетельство об истине, особенно о Христе.",
    u: "Используется 37 раз в НЗ. Главная тема Евангелия от Иоанна.",
    e: "От μάρτυς (мартис) = свидетель"
  },
  "G3173": {
    m: "великий, важный",
    d: "Большой по размеру, количеству или важности; могучий, дивный.",
    u: "Используется 243 раза в НЗ. Величие Божие.",
    e: "Первичный корень"
  },
  "G3320": {
    m: "стена разделения",
    d: "Средостенная стена, перегородка разделения.",
    u: "Используется 1 раз в НЗ (Еф 2:14). Стена между иудеями и язычниками.",
    e: "От μέσος (месос) = средний + τοῖχος (тойхос) = стена"
  },
  "G3439": {
    m: "единородный, единственный рождённый",
    d: "Единственный в своём роде, единородный; единственный сын.",
    u: "Используется 9 раз в НЗ. Единородный Сын Божий.",
    e: "От μόνος (монос) = один + γίνομαι (гиномай) = становиться"
  },
  "G3474": {
    m: "безумие, глупость",
    d: "Безумие, нелепость; то, что лишено мудрости.",
    u: "Используется 5 раз в НЗ. Премудрость Божия кажется безумием миру.",
    e: "От μωρός (морос) = глупый, безрассудный"
  },
  "G3475": {
    m: "Моисей",
    d: "Моисей, законодатель Израиля.",
    u: "Используется 80 раз в НЗ. Закон Моисея.",
    e: "От еврейского מֹשֶׁה (Моше) = извлечённый (из воды)"
  },
  "G3530": {
    m: "Никодим",
    d: "Никодим, собственное имя. Фарисей и иудейский начальник, пришедший к Иисусу ночью. Греческое имя означает 'победа народа'.",
    u: "Используется 5 раз в НЗ. Важный персонаж в Евангелии от Иоанна.",
    e: "От греческого νίκη (никэ) = победа и δῆμος (демос) = народ"
  },
  "G3551": {
    m: "закон, Тора",
    d: "Закон, Тора, правило, принцип. Закон Моисея, божественный закон, заповеди Божьи.",
    u: "Используется 194 раза в НЗ. Центральное понятие божественного откровения.",
    e: "От νέμω (немо) = распределять, давать; данный закон"
  },
  "G3571": {
    m: "ночь",
    d: "Ночь, период тьмы между закатом и восходом солнца. Часто метафора духовного невежества.",
    u: "Используется 61 раз в НЗ. Противопоставляется свету в иоанновской символике.",
    e: "Первичное женское существительное; ночь"
  },
  "G3598": {
    m: "путь, дорога",
    d: "Дорога, путь; образ жизни, поведение; путь спасения.",
    u: "Используется 101 раз в НЗ. Иисус есть путь.",
    e: "Первичный корень"
  },
  "G3609": {
    m: "домашний, из дома",
    d: "Принадлежащий к дому, член семьи; домашний слуга.",
    u: "Используется 3 раза в НЗ. Описывает членов семьи Божией.",
    e: "От οἶκος (ойкос) = дом"
  },
  "G3664": {
    m: "подобный, похожий",
    d: "Подобный, той же природы или характера; равнозначный.",
    u: "Используется 45 раз в НЗ. Вторая заповедь подобна первой.",
    e: "От ὁμός (хомос) = тот же"
  },
  "G3686": {
    m: "имя",
    d: "Имя, титул; репутация; власть, могущество.",
    u: "Используется 228 раз в НЗ. Имя Иисуса.",
    e: "Первичный корень"
  },
  "G3708": {
    m: "видеть, смотреть",
    d: "Видеть глазами; воспринимать, понимать; являться.",
    u: "Используется 454 раза в НЗ. Видеть Христа, видеть Отца.",
    e: "Первичный корень"
  },
  "G3735": {
    m: "гора, холм",
    d: "Гора, высокое место; возвышенный холм.",
    u: "Используется 63 раза в НЗ. Гора Преображения.",
    e: "Вероятно от ὁράω (хорао) = видеть"
  },
  "G3756": {
    m: "не, нет",
    d: "Абсолютное отрицание, нет, не.",
    u: "Используется более 1600 раз в НЗ. Очень частая отрицательная частица.",
    e: "Первичная отрицательная частица"
  },
  "G3762": {
    m: "никто, ничто, никакой",
    d: "Никто, ничто, никакой, ни один. Абсолютное отрицание существования или количества.",
    u: "Используется 234 раза в НЗ. Сильное отрицание очень часто.",
    e: "От οὐδέ (удэ) и εἷς (хейс); даже не один"
  },
  "G3778": {
    m: "этот, эта, это",
    d: "Указательное местоимение: этот, эта, это. Обозначает что-то близкое или ранее упомянутое.",
    u: "Используется 1388 раз в НЗ. Самое частое указательное местоимение.",
    e: "Первичное указательное местоимение"
  },
  "G3789": {
    m: "змей",
    d: "Змей, пресмыкающееся; древний змий (сатана).",
    u: "Используется 14 раз в НЗ. Медный змей в пустыне.",
    e: "Первичный корень"
  },
  "G3793": {
    m: "толпа, множество",
    d: "Толпа людей, множество; народная масса.",
    u: "Используется 175 раз в НЗ. Толпы, следовавшие за Иисусом.",
    e: "От ὄχος (охос) = повозка (которая несёт)"
  },
  "G3880": {
    m: "получать, брать, принимать",
    d: "Получать, брать, принимать, схватывать. Получать что-то предлагаемое или даваемое.",
    u: "Используется 59 раз в НЗ. Центральное понятие принятия Евангелия.",
    e: "От παρά (пара) = рядом и λαμβάνω (ламбано) = брать"
  },
  "G3956": {
    m: "всякий, каждый",
    d: "Всякий, каждый, все; целое, полнота.",
    u: "Используется 1244 раза в НЗ. Среди самых частых слов.",
    e: "Первичный корень"
  },
  "G3962": {
    m: "отец",
    d: "Природный или духовный отец; предок; Бог Отец.",
    u: "Используется 413 раз в НЗ. Часто для обозначения Бога.",
    e: "Первичный корень, родственен латинскому 'pater'"
  },
  "G4100": {
    m: "верить, иметь веру",
    d: "Иметь веру в, верить; доверяться, полагаться на.",
    u: "Используется 241 раз в НЗ. Верить в Иисуса для спасения.",
    e: "От πίστις (пистис) = вера"
  },
  "G4102": {
    m: "вера, доверие, верность",
    d: "Убеждённость в истинности чего-либо, вера; в НЗ убеждение, касающееся отношений человека с Богом и божественных вещей.",
    u: "Используется 244 раза в НЗ. Центральное понятие христианской веры.",
    e: "От πείθω (пейтхо) = убеждать, уверять"
  },
  "G4138": {
    m: "полнота, изобилие, то что наполняет",
    d: "Полнота, изобилие, то что полностью наполняет. Целостность, божественная полнота.",
    u: "Используется 17 раз в НЗ. Богословское понятие божественной полноты во Христе.",
    e: "От πλήρης (плерес) = полный; полнота"
  },
  "G4139": {
    m: "ближний, сосед",
    d: "Тот, кто близок, сосед; ближний в общем смысле.",
    u: "Используется 17 раз в НЗ. 'Возлюби ближнего твоего как самого себя'.",
    e: "Наречие, ставшее существительным, от πλησίος (плесиос) = близкий"
  },
  "G4151": {
    m: "дух, дыхание, ветер",
    d: "Дыхание жизни, жизненное начало; разумная душа; Святой Дух.",
    u: "Используется 385 раз в НЗ. Обозначает Святого Духа, дух человека или духов.",
    e: "От πνέω (пнео) = дуть, дышать"
  },
  "G4160": {
    m: "делать, совершать, исполнять",
    d: "Делать, совершать, производить, действовать, творить. Общий глагол действия, охватывающий все виды деятельности.",
    u: "Используется 568 раз в НЗ. Основной глагол действия, часто в делах Божьих.",
    e: "Первичный глагол; делать, совершать"
  },
  "G4166": {
    m: "пастырь, пастух",
    d: "Тот, кто пасёт овец; духовный страж, пастырь церкви.",
    u: "Используется 18 раз в НЗ. Иисус добрый пастырь.",
    e: "От ποίμνη (пойм не) = стадо"
  },
  "G4183": {
    m: "много, многие, большой",
    d: "Много, многие, большой по количеству или числу. Множество, большое количество.",
    u: "Используется 416 раз в НЗ. Очень частое количественное прилагательное.",
    e: "Неопределённый корень; много, многие"
  },
  "G4198": {
    m: "идти, ходить, путешествовать",
    d: "Идти, ходить, путешествовать, двигаться. Движение из одного места в другое, часто с целью.",
    u: "Используется 154 раза в НЗ. Основной глагол движения в евангельских повествованиях.",
    e: "Первичный глагол; идти, ходить"
  },
  "G4238": {
    m: "делать, практиковать, совершать",
    d: "Делать, практиковать, совершать, действовать. Выполнять действия, часто с идеей повторения или привычки.",
    u: "Используется 39 раз в НЗ. Часто связано с практикой добра или зла.",
    e: "Усиленная форма от πράω (прао); делать, практиковать"
  },
  "G4263": {
    m: "овца",
    d: "Овца или баран; метафорически, ученики Христа.",
    u: "Используется 39 раз в НЗ. Верующие как овцы пастыря.",
    e: "Вероятно связано с προβαίνω (пробайно) = идти вперёд"
  },
  "G4413": {
    m: "первый, главный",
    d: "Первый по времени, месту, порядку или важности.",
    u: "Используется 155 раз в НЗ. Первая заповедь, первое место.",
    e: "Превосходная степень от πρό (про) = перед"
  },
  "G4561": {
    m: "плоть, тело",
    d: "Плоть, мясо; человеческое тело; падшая человеческая природа.",
    u: "Используется 147 раз в НЗ. Контраст между плотью и духом.",
    e: "Первичный корень"
  },
  "G4592": {
    m: "знамение, чудо, знак",
    d: "Знамение, чудо, знак; сверхъестественное проявление, открывающее божественную силу.",
    u: "Используется 77 раз в НЗ. 'ибо никто не может творить таких чудес, какие Ты творишь' (Иоан. 3:2).",
    e: "От σημεῖον (семейон) = знак, отметка"
  },
  "G4648": {
    m: "смотреть внимательно, целиться",
    d: "Устремлять взор на, рассматривать внимательно; иметь в виду, целиться в цель.",
    u: "Используется 6 раз в НЗ. Призыв устремлять взор на Христа.",
    e: "Связано с σκοπός (скопос) = цель, мишень"
  },
  "G4680": {
    m: "мудрый, знающий",
    d: "Мудрый, разумный, искусный; образованный, учёный.",
    u: "Используется 22 раза в НЗ. Истинная премудрость от Бога.",
    e: "Первичный корень"
  },
  "G4982": {
    m: "спасать, избавлять",
    d: "Спасать от опасности или гибели; избавлять от греха.",
    u: "Используется 106 раз в НЗ. Иисус спасает грешников.",
    e: "От σῶς (сос) = невредимый и целый"
  },
  "G5040": {
    m: "малое дитя",
    d: "Маленький ребёнок, младенец; ласковый термин для ученика.",
    u: "Используется 8 раз в НЗ. Иоанн называет своих читателей 'малые дети'.",
    e: "Уменьшительное от τέκνον (текнон) = дитя"
  },
  "G5087": {
    m: "полагать, класть, устанавливать",
    d: "Ставить, помещать; устанавливать, назначать; полагать, класть.",
    u: "Используется 100 раз в НЗ. Полагать душу свою за овец.",
    e: "Первичный корень"
  },
  "G5109": {
    m: "стена",
    d: "Разделяющая стена, перегородка.",
    u: "Используется 1 раз в НЗ (Деян 23:3).",
    e: "Первичный корень"
  },
  "G5207": {
    m: "сын",
    d: "Потомок мужского пола; ученик; член группы. Сын Божий = Иисус Христос.",
    u: "Используется 377 раз в НЗ. Часто для обозначения Иисуса как Сына Божия.",
    e: "Происхождение неясно, возможно связано с ὕω (хюо) = проливать дождь, порождать"
  },
  "G5281": {
    m: "терпение, выносливость, настойчивость",
    d: "Качество того, кто не поддаётся обстоятельствам или давлению; терпеливая выносливость, постоянство.",
    u: "Используется 32 раза в НЗ. Важнейшая христианская добродетель.",
    e: "От ὑπό (хюпо) = под и μένω (мено) = оставаться"
  },
  "G5312": {
    m: "возносить, превозносить",
    d: "Поднимать высоко, возносить; превозносить, почитать.",
    u: "Используется 20 раз в НЗ. Сын Человеческий вознесён.",
    e: "От ὕψος (хюпсос) = высота"
  },
  "G5376": {
    m: "Филипп",
    d: "Филипп, собственное имя. Один из двенадцати апостолов. Греческое имя означает 'любитель лошадей'.",
    u: "Используется 36 раз в НЗ. Имя апостола и диакона.",
    e: "От греческого φίλος (филос) = друг и ἵππος (гиппос) = лошадь"
  },
  "G5432": {
    m: "хранить, защищать",
    d: "Хранить военной охраной; защищать, сохранять.",
    u: "Используется 4 раза в НЗ. Мир Божий хранит сердца наши.",
    e: "От φρουρός (фрурос) = стража, часовой"
  },
  "G5443": {
    m: "племя, род",
    d: "Племя, клан; народ, происходящий от общего предка.",
    u: "Используется 31 раз в НЗ. Двенадцать колен Израиля.",
    e: "От φύω (фюо) = производить, растить"
  },
  "G5457": {
    m: "свет",
    d: "Физический или духовный свет; откровенная божественная истина.",
    u: "Используется 73 раза в НЗ. Иисус свет мира.",
    e: "От φάω (фао) = сиять"
  },
  "G5463": {
    m: "радоваться, быть радостным",
    d: "Радоваться, быть счастливым; приветствие 'радуйся' или 'здравствуй'.",
    u: "Используется 74 раза в НЗ. Частое повеление радоваться во Христе.",
    e: "Родственно χάρις (харис) = благодать"
  },
  "G5495": {
    m: "рука",
    d: "Рука; власть, могущество; действие, дело.",
    u: "Используется 177 раз в НЗ. Рука Божия, руки Иисуса.",
    e: "Первичный корень"
  },
  "G5544": {
    m: "доброта, благость",
    d: "Доброта в действии, практическое благоволение; качество того, кто полезен и благотворен для других.",
    u: "Используется 10 раз в НЗ. Плод Духа согласно Галатам 5:22.",
    e: "От χρηστός (хрестос) = добрый, полезный, благой"
  },
  "G5547": {
    m: "Христос, Мессия, Помазанник",
    d: "Помазанник, Мессия; титул Иисуса как обетованного Спасителя.",
    u: "Используется 529 раз в НЗ. Иисус есть Христос.",
    e: "От χρίω (хрио) = помазывать"
  },
  "G5590": {
    m: "душа, жизнь",
    d: "Дыхание жизни, жизненная душа; сама жизнь; бессмертная душа.",
    u: "Используется 105 раз в НЗ. Духовная и вечная жизнь.",
    e: "От ψύχω (псюхо) = дышать, освежать"
  },
  "H120": {
    m: "человек, человечество, Адам",
    d: "Человек, человеческое существо; человечество; Адам первый человек.",
    u: "Используется 562 раза в ВЗ. Бог сотворил человека.",
    e: "От אָדֹם (адом) = красный, или אֲדָמָה (адама) = земля"
  },
  "H160": {
    m: "любовь, привязанность",
    d: "Любовь, привязанность; акт любви.",
    u: "Используется 40 раз в ВЗ. Любовь Божия к Своему народу.",
    e: "От אָהַב (ахав) = любить"
  },
  "H216": {
    m: "свет",
    d: "Естественный или духовный свет; счастье, благополучие.",
    u: "Используется 120 раз в ВЗ. 'Да будет свет!'",
    e: "От אוֹר (ор) = быть светлым"
  },
  "H430": {
    m: "Бог, боги",
    d: "Всевышний Бог (Элохим); иногда используется для судей или языческих богов.",
    u: "Используется 2606 раз в ВЗ. Множественное число величия для Бога.",
    e: "Множественное от אֱלוֹהַּ (элоах) = бог"
  },
  "H559": {
    m: "говорить, сказать",
    d: "Говорить, сказать, объявлять; повелевать, думать.",
    u: "Используется 5316 раз в ВЗ. Самый частый глагол речи.",
    e: "Первичный корень"
  },
  "H776": {
    m: "земля, страна",
    d: "Земля, почва; страна, область; земной мир.",
    u: "Используется 2504 раза в ВЗ. Земля, которую сотворил Бог.",
    e: "Первичный корень"
  },
  "H982": {
    m: "надеяться, доверять",
    d: "Надеяться на, доверять; быть в безопасности.",
    u: "Используется 120 раз в ВЗ. Упование на Господа.",
    e: "Первичный корень"
  },
  "H1004": {
    m: "дом, жилище",
    d: "Дом, жилище; семья, домочадцы; храм.",
    u: "Используется 2055 раз в ВЗ. Дом Господень.",
    e: "От בָּנָה (бана) = строить"
  },
  "H1254": {
    m: "творить",
    d: "Творить из ничего; формировать, делать; исключительная деятельность Бога.",
    u: "Используется 54 раза в ВЗ. Бог сотворил небо и землю.",
    e: "Первичный корень"
  },
  "H1516": {
    m: "долина, ущелье",
    d: "Долина, теснина, ущелье; равнина.",
    u: "Используется 60 раз в ВЗ. Долина тени смертной.",
    e: "Первичный корень"
  },
  "H1878": {
    m: "утучнять, делать жирным",
    d: "Делать жирным, утучнять; процветать.",
    u: "Используется 11 раз в ВЗ. Ты умастил елеем главу мою.",
    e: "От דֶּשֶׁן (дешен) = жир, пепел"
  },
  "H1980": {
    m: "ходить, идти",
    d: "Ходить, идти, приходить; жить, вести себя.",
    u: "Используется 1554 раза в ВЗ. Очень частый глагол движения.",
    e: "Первичный корень"
  },
  "H2617": {
    m: "милость, благость, верность",
    d: "Милость, благость; верность завету; верная любовь.",
    u: "Используется 248 раз в ВЗ. Благость Господня.",
    e: "От חָסַד (хасад) = быть добрым, милостивым"
  },
  "H2637": {
    m: "недоставать, нуждаться",
    d: "Недоставать, нуждаться; убывать, не хватать.",
    u: "Используется 23 раза в ВЗ. Ни в чём не буду нуждаться (Пс 22:1).",
    e: "Первичный корень"
  },
  "H2896": {
    m: "добрый, хороший",
    d: "Добрый, приятный, превосходный; благой, справедливый.",
    u: "Используется 559 раз в ВЗ. Бог увидел, что это хорошо.",
    e: "Первичный корень"
  },
  "H3068": {
    m: "Господь, Яхве",
    d: "Собственное имя Бога, священный тетраграмматон YHWH.",
    u: "Используется 6828 раз в ВЗ. Самое святое имя.",
    e: "От הָיָה (хайя) = быть, существовать"
  },
  "H3117": {
    m: "день",
    d: "День (противоположность ночи); период в 24 часа; эпоха, время.",
    u: "Используется 2301 раз в ВЗ. День, который создал Господь.",
    e: "От יוֹם (йом) = быть горячим"
  },
  "H3372": {
    m: "бояться, страшиться, благоговеть",
    d: "Бояться, страшиться; благоговеть, почитать Бога.",
    u: "Используется 335 раз в ВЗ. Не убоюсь зла.",
    e: "Первичный корень"
  },
  "H3563": {
    m: "чаша",
    d: "Чаша, кубок; доля, участь.",
    u: "Используется 31 раз в ВЗ. Чаша моя преисполнена.",
    e: "Первичный корень"
  },
  "H3820": {
    m: "сердце, дух",
    d: "Сердце, седалище эмоций; дух, разум, воля.",
    u: "Используется 598 раз в ВЗ. Сердце человека.",
    e: "Первичный корень"
  },
  "H3915": {
    m: "ночь",
    d: "Ночь (противоположность дня); время темноты.",
    u: "Используется 234 раза в ВЗ. Бог отделил день от ночи.",
    e: "Первичный корень"
  },
  "H3966": {
    m: "очень, весьма",
    d: "Очень, весьма, много; сильно, быстро.",
    u: "Используется 300 раз в ВЗ. Это было весьма хорошо.",
    e: "От מָאַד (меод) = быть многим"
  },
  "H4325": {
    m: "вода, воды",
    d: "Вода, воды; дождь; поток, море.",
    u: "Используется 585 раз в ВЗ. Воды творения.",
    e: "Двойственное от מַיִם (майим) = вода"
  },
  "H4999": {
    m: "пастбище, жилище",
    d: "Место пастбища, луг; жилище, обитель.",
    u: "Используется 13 раз в ВЗ. На злачных пажитях.",
    e: "От נָאָה (наа) = быть прекрасным, подходящим"
  },
  "H5148": {
    m: "вести, направлять",
    d: "Вести, направлять, руководить; вести в безопасности.",
    u: "Используется 40 раз в ВЗ. Он ведёт меня (Пс 22:3).",
    e: "Первичный корень"
  },
  "H5216": {
    m: "пастбище, обработанная земля",
    d: "Луг, пастбище; обработанная земля, поле.",
    u: "Используется 2 раза в ВЗ. Злачные пажити.",
    e: "От נִיר (нир) = пахать"
  },
  "H5315": {
    m: "душа, жизнь, личность",
    d: "Душа, жизнь, живое существо; личность, я; желание, аппетит.",
    u: "Используется 753 раза в ВЗ. Душа моя, жизнь моя.",
    e: "От נָפַשׁ (нафаш) = дышать"
  },
  "H5769": {
    m: "вечность, навсегда",
    d: "Неопределённое время, вечность; всегда, навсегда.",
    u: "Используется 439 раз в ВЗ. Вечная любовь Божия.",
    e: "От עָלַם (алам) = скрывать, быть скрытым"
  },
  "H6186": {
    m: "устраивать, располагать",
    d: "Устраивать в порядке, располагать; готовить трапезу.",
    u: "Используется 75 раз в ВЗ. Ты приготовил трапезу (Пс 22:5).",
    e: "Первичный корень"
  },
  "H6213": {
    m: "делать, совершать",
    d: "Делать, изготовлять, совершать; действовать, работать.",
    u: "Используется 2632 раза в ВЗ. Очень частый глагол.",
    e: "Первичный корень"
  },
  "H6664": {
    m: "правда, праведность",
    d: "Правда, праведность, справедливость; верность.",
    u: "Используется 119 раз в ВЗ. Стези правды.",
    e: "От צָדַק (цадак) = быть праведным"
  },
  "H6754": {
    m: "образ, подобие",
    d: "Образ, подобие; форма, вид.",
    u: "Используется 17 раз в ВЗ. Человек, сотворённый по образу Божию.",
    e: "От צָלַל (цалал) = затенять, быть подобным"
  },
  "H6757": {
    m: "тень смерти, глубокая тьма",
    d: "Глубокая тьма, смертельная темнота; тень смерти.",
    u: "Используется 18 раз в ВЗ. Символизирует крайнюю опасность.",
    e: "От צֵל (цел) = тень + מָוֶת (мавет) = смерть"
  },
  "H6887": {
    m: "быть в бедствии, противник",
    d: "Быть стеснённым, в беде; противник, враг.",
    u: "Используется 58 раз в ВЗ. Пред лицом врагов моих.",
    e: "Первичный корень"
  },
  "H7121": {
    m: "призывать, взывать, провозглашать",
    d: "Призывать, взывать; называть; провозглашать, созывать.",
    u: "Используется 736 раз в ВЗ. Призывать имя Господне.",
    e: "Первичный корень"
  },
  "H7200": {
    m: "видеть, смотреть",
    d: "Видеть глазами; воспринимать, понимать; обеспечивать.",
    u: "Используется 1311 раз в ВЗ. Бог увидел, что это хорошо.",
    e: "Первичный корень"
  },
  "H7225": {
    m: "начало, первенцы",
    d: "Начало, начало; лучшее, первенцы.",
    u: "Используется 51 раз в ВЗ. 'В начале сотворил Бог...'",
    e: "От רֹאשׁ (рош) = голова, начало"
  },
  "H7257": {
    m: "лежать, покоиться",
    d: "Лежать, покоиться; пребывать; высиживать.",
    u: "Используется 30 раз в ВЗ. Он покоит меня (Пс 22:2).",
    e: "Первичный корень"
  },
  "H7291": {
    m: "преследовать, гнаться",
    d: "Преследовать, гнаться; притеснять; следовать вплотную.",
    u: "Используется 144 раза в ВЗ. Благость будет сопровождать меня.",
    e: "Первичный корень"
  },
  "H7307": {
    m: "дух, дыхание, ветер",
    d: "Дыхание, ветер; дух Божий или человека; умонастроение.",
    u: "Используется 378 раз в ВЗ. Дух Божий.",
    e: "От רוּחַ (руах) = дуть"
  },
  "H7462": {
    m: "пасти, пастись, кормить",
    d: "Пасти стадо; быть пастухом; кормить, ухаживать.",
    u: "Используется 173 раза в ВЗ. Господь пастырь мой.",
    e: "Первичный корень"
  },
  "H7549": {
    m: "твердь, небесный свод",
    d: "Простор, небесный свод, твердь; небо.",
    u: "Используется 17 раз в ВЗ. Твердь посреди воды.",
    e: "От רָקַע (рака) = простирать, распространять"
  },
  "H7626": {
    m: "жезл, колено",
    d: "Жезл, посох; колено, семейная ветвь.",
    u: "Используется 190 раз в ВЗ. Жезл Твой и посох Твой.",
    e: "От שָׁבַט (шабат) = ветвиться"
  },
  "H7725": {
    m: "возвращаться, восстанавливать",
    d: "Возвращаться, вернуться; восстанавливать, обновлять; каяться.",
    u: "Используется 1058 раз в ВЗ. Восстановить душу мою.",
    e: "Первичный корень"
  },
  "H7979": {
    m: "стол",
    d: "Стол для еды; стол хлебов предложения.",
    u: "Используется 71 раз в ВЗ. Приготовленный стол.",
    e: "От שָׁלַח (шалах) = посылать, простирать"
  },
  "H8064": {
    m: "небеса, небо",
    d: "Небеса, твердь; обитель Бога; видимое небо.",
    u: "Используется 420 раз в ВЗ. Небо и земля.",
    e: "Двойственное от שָׁמַיִם (шамайим) = высоты"
  },
  "H8414": {
    m: "безвидный, пустой, хаос",
    d: "Пустыня, запустение; хаос, пустота, ничто.",
    u: "Используется 20 раз в ВЗ. Земля была безвидна и пуста.",
    e: "От תָּהָה (таха) = блуждать"
  }
};

export default strongTranslationsRU;
